import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import { cn } from "@/utils/utils";
import { DreamhubGradient } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import { Divider } from "@/components/ui/divider";
import Summary from "@/components/layouts/FromDreamer/Summary";
import DealAlerts from "@/components/layouts/FromDreamer/DealAlerts";
import { AlertData } from "@/pages/deals/types";

const TRANSLATION_PREFIX = "fromDreamer";

interface Props {
  entityType: EntityType.DEAL | EntityType.LEAD;
  entityId: string;
  alerts?: AlertData[] | null;
  className?: string;
  showSummary?: boolean;
  isQuickView?: boolean;
}

const FromDreamer: React.FC<Props> = ({
  entityType,
  entityId,
  alerts,
  className,
  showSummary = false,
  isQuickView = false
}) => {
  const { t } = useTranslation();
  const [hasSummary, setHasSummary] = React.useState(false);

  return (
    <div
      className={cn(
        "flex flex-col gap-6 border-[0.5px] border-border-border1 w-full rounded-xl",
        isQuickView ? "bg-surface-elevation2 p-4" : "bg-surface-elevation1 p-6",
        className
      )}
      data-test={`${entityType}-from-dreamer`}
    >
      <div
        className="flex gap-2 items-center"
        data-test={`${entityType}-from-dreamer-header`}
      >
        <IconContainer size="md">
          <DreamhubGradient />
        </IconContainer>
        <Text variant={isQuickView ? "lgLabel" : "lgSubtitleH1"}>
          {t(`${TRANSLATION_PREFIX}.title`)}
        </Text>
      </div>
      {showSummary && entityType === EntityType.DEAL && (
        <>
          <Summary
            tPrefix={TRANSLATION_PREFIX}
            entityType={entityType}
            entityId={entityId}
            onHasContent={setHasSummary}
          />
          {hasSummary && <Divider />}
        </>
      )}
      <DealAlerts
        tPrefix={TRANSLATION_PREFIX}
        dealId={entityId}
        alerts={alerts || []}
      />
    </div>
  );
};

export default FromDreamer;
